import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { generateFileUrl } from '../../../../apiHelper';
import { updateFormData, updateListingPhotos } from '../../../dashboard/listing/actions';
import { populateFormDataFromListing } from '../../../dashboard/listing/helpers';

// Create an editable cell renderer
const ActionsCell = ({
  cell: { value: initialValue },
  data: listing,
  dispatch,
  history
}) => {

  function editListing() {
    let formData = populateFormDataFromListing(listing);
    dispatch(updateFormData(formData));
    history.push('/admin/listing/edit/details');
  }
  function editBasePricing() {
    let formData = populateFormDataFromListing(listing);
    dispatch(updateFormData(formData));
    history.push('/admin/listing/edit/pricing');
  }
  function editListingCalendar() {
    let formData = populateFormDataFromListing(listing);
    dispatch(updateFormData(formData));
    history.push('/admin/listing/edit/calendars');
  }
  function editPhotos() {
    let formData = populateFormDataFromListing(listing);
    dispatch(updateFormData(formData));
    let photoPreviews = formData.photos.map(x => ({ name: x, preview: generateFileUrl(x, formData.id) }));
    dispatch(updateListingPhotos(photoPreviews));
    history.push('/admin/listing/edit/photos');
  }

  return <div className="d-flex">
    <Link to={`/listing/${listing._id}`} title="View Listing"><button className="btn btn-secondary"><i className="far fa-eye"></i></button></Link>
    <button className="btn btn-secondary" onClick={editListing} title="Edit Listing"><i className="fas fa-pencil-alt"></i></button>
    <button className="btn btn-secondary" onClick={editBasePricing} title="Edit Base Pricing"><i className="fas fa-dollar-sign"></i></button>
    <button className="btn btn-secondary" onClick={editListingCalendar} title="Edit Calendar / Pricing"><i className="fas fa-calendar-alt"></i></button>
    <button className="btn btn-secondary" onClick={editPhotos} title="Edit Photos"><i className="fas fa-camera"></i></button>
  </div>
}
export default withRouter(connect()(ActionsCell));
